var map = {
	"./ALB.svg": "3e81",
	"./AUS.svg": "b950",
	"./BEL.svg": "4544",
	"./BIE.svg": "6c89",
	"./BOS.svg": "944b",
	"./BUL.svg": "2db5",
	"./CEC.svg": "a5ea",
	"./CIP.svg": "3543",
	"./CRO.svg": "32be",
	"./DAN.svg": "6739",
	"./EST.svg": "df72",
	"./FIN.svg": "2cf6",
	"./FRA.svg": "d390",
	"./GER.svg": "7c0d",
	"./GRE.svg": "9f05",
	"./IRL.svg": "9e93",
	"./ISL.svg": "0157",
	"./ITA.svg": "faf7",
	"./KOS.svg": "2f00",
	"./LET.svg": "e3e3",
	"./LUS.svg": "ceef",
	"./MAC.svg": "e159",
	"./MAL.svg": "b7d4",
	"./MOL.svg": "93dd",
	"./MON.svg": "83ea",
	"./NOR.svg": "2e25",
	"./OLA.svg": "e099",
	"./POL.svg": "d334",
	"./POR.svg": "6747",
	"./ROM.svg": "acb1",
	"./RUS.svg": "6540",
	"./SER.svg": "7dfe",
	"./SLOVA.svg": "e51f",
	"./SLOVE.svg": "7c2a",
	"./SPA.svg": "2f8f",
	"./SVE.svg": "fe84",
	"./SVI.svg": "efd7",
	"./TUR.svg": "3009",
	"./UCR.svg": "c410",
	"./UK.svg": "672a",
	"./UNG.svg": "1dfd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8e83";